import React from "react";
import { useEffect } from "react";
import { Button } from "antd";
import { AudioOutlined } from "@ant-design/icons";
import { Messages, ChatInput } from "./components";
import { useTranslation } from "react-i18next";

const ChatbotMessages = ({
  chatInput,
  handleChatInputChange,
  handleSendMessage,
  conversation,
}) => {
  const selectedBotName = "Copilotly";

  const { t } = useTranslation();

  useEffect(() => {
    // Scroll to the bottom of the chatContainer
    const chatContainer = document.getElementById("chatMessageContainer");

    if (chatContainer) {
      setTimeout(() => {
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [chatInput]);

  return (
    <>
      <>
        <div>
          {/* Chat Message Header  */}
          <div className="chatbot-message-header">
            {/* Chatbot Name and Logo */}
            <div className="header-left">
              <div className="chatbot-logo">
                {selectedBotName.split(" ").length > 1
                  ? selectedBotName.split(" ")[0][0] +
                    selectedBotName.split(" ")[1][0]
                  : selectedBotName[0]}
              </div>
              <div className="header-details">
                <div className="chatbot-name">{selectedBotName}</div>
                <div
                  style={{
                    fontSize: "0.9em",
                    fontWeight: 600,
                    color: "#0b4eb8",
                  }}
                >
                  Visitor #12341234
                </div>
              </div>
            </div>

            {/* Chat Date */}
            {/* <div className="header-right">
              {Object.keys(selectedChat).length > 0 && (
                <ChatDate dateTime={selectedChat.chatDate} />
              )}
            </div> */}
          </div>

          {/* Chatbot Messages */}
          <div className="chatbot-message-container" id="chatMessageContainer">
            <Messages conversation={conversation} />
          </div>

          {/* Input */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              background: "#fff",
            }}
          >
            {/* Chat Input */}
            <ChatInput
              initialContent={chatInput.message}
              handleChatInputChange={handleChatInputChange}
              placeholderText="Type your message here!"
              disabled={false}
              handleSendMessage={handleSendMessage}
            />

            {/* Chat Input Options */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "-20px",
                border: "1px solid #ccc",
                borderTop: "none",
                padding: "4px 8px",
              }}
            >
              {/* LEFT OPTIONS */}
              <div>
                {/* Voice */}
                <Button
                  type="text"
                  icon={<AudioOutlined size={15} />}
                  size="small"
                  style={{
                    borderRadius: "4px",
                    marginRight: "6px",
                  }}
                  disabled
                />
              </div>

              {/* RIGHT OPTIONS */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* End Chat Button */}
                <Button
                  type="danger"
                  size="small"
                  style={{ marginRight: "10px" }}
                >
                  {t("chatMessages.messages.endChat")}
                </Button>

                {/* Send Button */}
                <Button
                  type="primary"
                  size="small"
                  onClick={handleSendMessage}
                  style={{
                    background: "#0b4eb8",
                    borderColor: "#0b4eb8",
                  }}
                >
                  {t("chatMessages.messages.send")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ChatbotMessages;
